
import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

export function useBookingsDate(selectedDate?: Date, djId?: string | number) {
  return useQuery({
    queryKey: ["/api/bookings", selectedDate ? format(selectedDate, "yyyy-MM-dd") : null, djId], // Add djId to queryKey
    queryFn: async () => {
      if (!selectedDate) return [];
      const dateStr = format(selectedDate, "yyyy-MM-dd");
      let url = `/api/bookings?date=${dateStr}`;
      if (djId) {
        url += `&djId=${djId}`;
      }
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch bookings");
      return res.json();
    },
    enabled: !!selectedDate,
  });
}
